<template>
  <div class="xl:flex">
    <Nav class="w-full xl:w-1/6" />
    <div class="loyalty-programme-content text-left flex-1 w-full xl:w-5/6">

      <Spinner v-if="loyaltyStore.loading" />
      <template v-else>
        <div class="tier-grid grid grid-cols-2 gap-4 sm:grid-cols-4 sm:gap-4">
          <template v-for="tier in loyaltyStore.tiers"
            :key="tier.id"
          >
            <template v-for="reward in tier.rewards"
              :key="reward.id"
              :data-reward-id=reward.id
              :style="{ borderColor: tier.bgColor }"
            >
              <div v-if="isUserFavourite(reward)">
                <RewardBox :reward="reward" :color="`#fcd34d`" :favourite="isUserFavourite(reward)" />
              </div>
            </template>
          </template>
        </div>
      </template>

    </div>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from "vue-i18n";
import { computed, ref } from "vue";
import Spinner from "@/components/Spinner.vue";
import RewardBox from "@/components/loyalty-programme/rewardBox.vue";
import { useLoyalty } from "@/pinia/loyaltyStore";
import { storeToRefs } from "pinia";
import Nav from "@/pages/loyalty-programme/nav.vue";

const {t} = useI18n();

const loyaltyStore = useLoyalty();
const { isUserFavourite } = storeToRefs(loyaltyStore);

async function initialize() {
  await loyaltyStore.fetch();
}
initialize();

</script>
